import styled from "styled-components";

export const BagContainer = styled.div`
    position: fixed;
    width: 70px;
    height: 70px;
    background-color: #333;
    right: 20px;
    bottom: 20px;
    z-index: 10;
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    div {
        position: absolute;
        background-color: red;
        width: 15px;
        height: 15px;
        font-size: 10px;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fafbfc;
        right: calc(50% - 15px );
        bottom: calc(50%);
    }

    img {
        width: 20px;
    }

    span {
        color: #fafbfc;
        font-size: 12px;
        text-align: center;
        margin-top: 5px;
    }
`;

export const Background = styled.div`
	position: fixed;
	width: 100%;
	height: 100dvh;
	background: rgba(0, 0, 0, 0.8);
	z-index: 999;
	display: ${(props) => (props.isOpen ? 'flex' : 'none')};
	justify-content: center;
	align-items: center;
	padding: 20px;
	box-sizing: border-box;
	overflow: hidden;
`;

export const BagPopupContainer = styled.div`
	width: 100%;
    height: fit-content;
    max-height: 60%;
	max-width: 400px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 4px 10px rgba(20, 20, 20, 0.5);
	z-index: 1000;
	max-height: 97%;
    overflow-y: hidden;
`;

export const InformationMessage = styled.span`
    color: #810000;
    margin: 10px;
    text-align: justify;
`;

export const BagHeader = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    span {
        font-weight: bold;
        color: #333;
        font-size: 20px;
    }

    button {
        color: #333;
    }

    button:hover {
        color: red;
    }
`;

export const BagItems = styled.div`
    height: 55%;
    overflow-y: scroll;

    span {
        color: #222;
    }
`;

export const BagItem = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    border: 0.5px solid #eee;
    margin: 10px;
    padding: 10px;
    border-radius: 4px;
    background-color: #fafbfc;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06);

    div {
        position: absolute;
        right: 5px;
        bottom: 5px;
        background-color: #810000;
        display: flex;
        border-radius: 4px;
        cursor: pointer;
        /* padding: 1px 5px; */
        /* width: fit-content; */
        width: auto;
        height: 24px;

        padding: 8px;
        align-items: center;
        justify-content: center;
        
        img {
            /* margin-right: 5px; */
            height: 16px;
            cursor: pointer;
        }

        span {
            color: #fff;
            font-size: 14px;
        }
    }

    div:hover {
        background-color: #B51C1C;
    }

`;

export const BagItemTitle = styled.span`
    font-weight: bold;
`;

export const BagButtons = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0px 50px;
    
    button {
        width: 250px;
        height: 30px;
        margin: 10px;
		background: #FEC108;
		color: white;
		border: none;
		border-radius: 8px;
		cursor: pointer;
	}

	button:hover {
		background: #FEC10890;
	}
`;